import { Button, Space } from '@bedrock/components';
import Icon from '@bedrock/icons-react';
import React from 'react';
import { ReactComponent as departmentLogo } from '../../images/department-logo.svg';
import { ReactComponent as mpcLogo } from '../../images/mpc-logo.svg';
import classNames from 'classnames/bind';
import styles from './index.less';
import { $sType } from '#utils';
import { REPORT_URL } from '#utils/CONST';
import dayjs from 'dayjs';
const cx = classNames.bind(styles);

const PageFooter: React.FC = () => {
  return (
    <div className={cx('page-tab-container__footer')}>
      <div className={cx('page-tab-container-footer__left')}>
        <Space size='s' align='center'>
          {$sType === 'inner' && <>
            <Icon component={departmentLogo} className="fs-18" />
            <span>效率工程部</span>
            <span>|</span>
          </>}
          <Icon component={mpcLogo} className="fs-18" />
          <span>{$sType === 'inner' ? 'MPC' : '网易市场渠道协同管理平台'}</span>
        </Space>
      </div>
      <div className={cx('page-tab-container-footer__right')}>
        {$sType === 'outer' && <Button type='text-neutral' onClick={() => window.open(REPORT_URL)}>
          <span className={cx('page-tab-container-footer__right-report')}>
            廉正举报
          </span>
        </Button>}
        网易公司版权所有 ©1997-{dayjs().format('YYYY')}
      </div>
    </div>
  );
}

export default PageFooter;